import {Component, inject, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GameTable} from '../../../../../shared/model/game-table';
import {Game} from '../../../../../shared/model/game';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-event-gdt-list-modal',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './event-gdt-list-modal.component.html'
})
export class EventGdtListModalComponent {
  public activeModal = inject(NgbActiveModal);

  @Input() gameTable!: GameTable;

  public searchQuery: string = '';

  public get filteredGames(): Game[] {
    const games = this.gameTable?.boardgames || [];
    let result = games;
    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      result = games.filter(g => g.gameName.toLowerCase().includes(q));
    }
    return result.sort((a, b) => a.gameName.localeCompare(b.gameName));
  }
}
